import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { displayValue } from "../../../helpers/TodayDate";
import { changeDateFormat } from "../../../helpers/DateFormat";
import SicilBilgileriListeleAPI from "../../../apis/OB/Get/SicilBilgileriListeleAPI";
import { Close as CloseIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const KisiSicilSecim: React.FunctionComponent<any> = (props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [sicilData, setSicilData] = useState<any[]>([]);
  const navigate = useNavigate();
  console.log("PROPS:", props);
  useEffect(() => {
    if (props.isOpen) {
      console.log(props);
      console.log(props.tcNo);
      const cleanPhone = props.cepTelefonu
        ? props.cepTelefonu.replace(/^\+9/, "").replace(/ /g, "")
        : undefined;
      SicilBilgileriListeleAPI.getSicilBilgileriListe(
        props.sicilKodu ? Number(props.sicilKodu) : undefined,
        props.tcNo ? props.tcNo.toString() : undefined,
        props.vergiNo ? props.vergiNo.toString() : undefined,
        cleanPhone
      )
        .then((res: any) => {
          if (res.data.length === 1) {
            props.setItem(res.data[0]);
            props.setIsOpen(false);
          } else if (res.data.length > 0) {
            setSicilData(res.data);
          } else {
            props.setItem(null);
          }
        })
        .catch((err) => {
          // Handle error
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [props.isOpen]);

  return (
    <Dialog
      open={props.isOpen}
      onClose={() => {
        if (sicilData.length !== 1) {
          navigate("/");
        }
        props.setIsOpen(false);
      }}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        <div>Lütfen Sicil Kodunuzu Seçiniz!</div>
        <IconButton
          aria-label="close"
          onClick={() => {
            if (sicilData.length !== 1) {
              navigate("/");
            }
            props.setIsOpen(false);
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Sicil Kodu</TableCell>
                  <TableCell>T.C Kimlik No</TableCell>
                  <TableCell>Adı</TableCell>
                  <TableCell>Soyadı</TableCell>
                  <TableCell>Doğum Yeri</TableCell>
                  <TableCell>Doğum Tarihi</TableCell>
                  <TableCell>Anne Adı</TableCell>
                  <TableCell>Baba Adı</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sicilData.length === 1 ? (
                  sicilData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Button
                          variant="contained"
                          onClick={() => {
                            props.setItem(item);
                            props.setIsOpen(false);
                          }}
                        >
                          Seç
                        </Button>
                      </TableCell>
                      <TableCell>{displayValue(item.sicilKodu)}</TableCell>
                      <TableCell>{displayValue(item.tcKimlikNo)}</TableCell>
                      <TableCell>{displayValue(item.adi)}</TableCell>
                      <TableCell>{displayValue(item.soyadi)}</TableCell>
                      <TableCell>{displayValue(item.dogumYeri)}</TableCell>
                      <TableCell>
                        {displayValue(changeDateFormat(item.dogumTarihi))}
                      </TableCell>
                      <TableCell>{displayValue(item.anneAdi)}</TableCell>
                      <TableCell>{displayValue(item.babaAdi)}</TableCell>
                    </TableRow>
                  ))
                ) : sicilData.length === 0?(
                  <TableRow>
                    <TableCell className="text-danger" colSpan={9}>
                      {props.vergiNo == null
                        ? "Girilen T.C Kimlik Numarasına ait bir sicil bulunamadı! Lütfen belediyenize başvurunuz."
                        : "Girilen Vergi Numarasına ait bir sicil bulunamadı! Lütfen belediyenize başvurunuz."}
                    </TableCell>
                  </TableRow>
                ):
                <TableRow>
                <TableCell className="text-danger" colSpan={9}>
                  {props.vergiNo == null
                    ? "Girilen T.C Kimlik Numarasına ait birden fazla sicil bulundu! Lütfen belediyenize başvurunuz."
                    : "Girilen Vergi Numarasına ait birden fazla sicil bulundu! Lütfen belediyenize başvurunuz."}
                </TableCell>
              </TableRow>
                }
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (sicilData.length !== 1) {
              navigate("/");
            }
            props.setIsOpen(false);
          }}
          color="primary"
        >
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KisiSicilSecim;
